import React from "react";
import { useAuth } from "./context/LoginContext";
import { getCookieData } from "./helper/api";

interface PrivateRouteProps {
  roles: number[];
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ roles, children }) => {
  const { user, logout } = useAuth();
  const userRole = getCookieData("roleId") ? Number(getCookieData("roleId")) : user ? user.role_id : null;
  const userData = getCookieData("userData");
  const useritem = userData ? JSON.parse(userData) : null;

  if (userRole && !roles.includes(userRole)) {
    return <div>Unauthorized</div>;
  }

  if (!useritem) {
    logout()
  }

  return <>{children}</>;
};

export default PrivateRoute;
